module.exports = __webpack_public_path__ + "4.3.2/img/01.45116874.png";